import styled from "styled-components";

import errorIcon from "../../assets/error.gif";
import successIcon from "../../assets/success.gif";
import useMobileView from "../../hooks/useMobileView";
import {
  DAVYS_GREY_100,
  DAVYS_GREY_800,
  ERROR_RED_800,
  SUCCESS_GREEN_800,
} from "./colors";
import FlexBox from "./FlexBox";
import { Body1, Body2, H3 } from "./Headings";
import { Modal } from "./Modal";

const Toast = styled.div`
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  background: ${({ appearance }) => {
    switch (appearance) {
      case "info":
        return DAVYS_GREY_800;
      case "success":
        return SUCCESS_GREEN_800;
      case "error":
        return ERROR_RED_800;
      default:
        return DAVYS_GREY_800;
    }
  }};
  box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.04);
  @media screen and (max-width: 768px) {
    display: flex;
    margin: 0 1rem;
    min-height: 3.5rem;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 2rem;
  }
`;

const TextMessage = styled(Body1)`
  color: ${DAVYS_GREY_100};
  font-weight: 700;
  @media screen and (max-width: 768px) {
    font-weight: 500;
    font-size: 0.875rem;
    text-align: center;
  }
`;

const Icon = styled.img`
  width: 3.75rem;
  height: 3.75rem;
`;

const CustomToast = ({
  appearance,
  children,
  showBottomToastOnMobile = false,
}) => {
  const isMobile = useMobileView();

  const isError = appearance === "error";

  if (isMobile && !showBottomToastOnMobile) {
    return (
      <Modal mobileWidth="90%" mobileHeight="auto" mobileBorderRadius="1rem">
        <FlexBox column align="center" rowGap="1rem" padding="1.5rem">
          <Icon
            src={isError ? errorIcon : successIcon}
            alt={isError ? "Error icon" : "Success icon"}
          />
          <FlexBox column align="center" rowGap="0.5rem">
            <H3 bold>{isError ? "Action Failed!" : "Action completed!"}</H3>
            <Body2 textAlign="center">{children}</Body2>
          </FlexBox>
        </FlexBox>
      </Modal>
    );
  }

  return (
    <Toast appearance={appearance}>
      <TextMessage>{children}</TextMessage>
    </Toast>
  );
};

export default CustomToast;
